import React from 'react';
import { SortButton } from 'views/components/compound';

const MemberActionArea = () => {
  return <SortButton />;
};

export default MemberActionArea;
